import React from 'react';
//import SignUp from '../../components/SignUp';

//import FormInput from '../../components/FormInput';
//import {Link} from 'react-router-dom';

// verificar colocar for=ID nos label
//import {useState} from 'react';


import Quiz from '../../../components/Quiz'

function Quiz_teste() {

  //-dj//console.log("\n\ninvi:Quiz:",)
  return(
      <Quiz quiz_data = {{id:1,n_pontos:10}}/>

  );
}
export default Quiz_teste;
